import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, OTO_LINK } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const OTOLinkTransactions = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.number,
				show: false
			},
			{
				field: 'otoOrderID',
				Header: 'otoOrderID',
				accessor: 'otoOrderId',
				filterType: FilterType.number,
				show: false
			},
			{
				field: 'orderNumber',
				Header: 'orderNumber',
				accessor: 'orderNumber',
				filterType: FilterType.string,
				width: 70
			},
			{
				field: 'description',
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string,
				width: 200,
				show: false,
				translate: true
			},
			{
				field: 'sellerAmount',
				Header: 'sellerAmount',
				accessor: 'sellerAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 90
			},
			{
				field: 'otoAmount',
				Header: 'otoAmount',
				accessor: 'otoAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 130
			},
			{
				field: 'authorizedAmount',
				Header: 'totalAmount',
				accessor: 'authorizedAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 70
			},
			{
				field: 'paymentType',
				Header: 'paymentType',
				accessor: 'paymentType',
				filterType: FilterType.enum,
				enumName: ENUMS.PAYMENT_METHOD_WITH_PROVIDER,
				width: 90
			},
			{
				field: 'status',
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				width: 100,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CREDIT_TRANSACTION_STATUS,
				showOnMobile: true
			},
			{
				field: 'chargeDate',
				Header: 'transferDate',
				accessor: 'chargeDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true,
				width: 100
			},
			{
				field: 'transactionDate',
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true,
				width: 100
			}
		],
		[]
	);

	return (
		<DynamicList
			id={DYNAMICLISTS.OTOLINK_TRANSACTIONS}
			columns={columns}
			fetchUrl={OTO_LINK.GET_OTO_LINK_TRANSACTIONS}
			actionObjectType={ACTION_OBJECT_TYPES.OTHER}
			defaultSort={[{ id: 'id', desc: true }]}
		/>
	);
};

export default OTOLinkTransactions;
